import { PATH_DASHBOARD } from 'src/routes/paths';

export const ADMIN_PATHS = [PATH_DASHBOARD.administration.root];

export const ROLES = {
  ADMIN: 'admin',
  USER: 'user'
};

export function isAdminRole(role: string | undefined | null): boolean {
  return String(role ?? '').toLowerCase() === ROLES.ADMIN;
}
